import { useConnect } from 'sb-redux-hook'
import { useAbValues, useCallback } from 'sb-hooks'
import { constants } from 'common/helpers'
import { useCouponProduct } from 'compositions/modals/cancelSubscription/util'

import { openDowngradeModal, openUnsubscribeSkipAMonthModal, openGiftOfferModal,
  openUnsubscribeReasonModal } from 'compositions/modals/cancelSubscription'


const getNextAction = ({ actions, index }) => {
  const action = actions[index]

  if (action) {
    const openNextModal = getNextAction({ actions, index: index + 1 })

    return () => action({ openNextModal })
  }
}

const coupon = constants.resubscribeTypes.resubfreeproduct


const useCancelSubscriptionModals = () => {
  const isNewCancelFlowEnabled = useAbValues(constants.abTests.unsubscriptionFlow) === 'b'

  const { isSkippable, billingPeriod, productsPerPeriod } = useConnect({
    isSkippable: 'models.subscription.isSkippable',
    billingPeriod: 'models.subscription.currPlan.billingPeriod',
    productsPerPeriod: 'models.subscription.currPlan.productsPerPeriod',
  })

  const { product, isFetching, fetch } = useCouponProduct({
    coupon,
    skip: !isNewCancelFlowEnabled,
  })

  const isDowngradeAvailable  = billingPeriod === 1 && productsPerPeriod > 1
  const isGiftOfferAvailable  = product && !isFetching

  const handleOpenGiftOfferModal = useCallback(({ openNextModal }) => {
    openGiftOfferModal({ product, coupon, openNextModal, onConfirm: fetch })
  }, [ product, fetch ])

  const openCancelSubscriptionModal = useCallback(() => {
    const modalsList = [
      isDowngradeAvailable && openDowngradeModal,
      isSkippable && openUnsubscribeSkipAMonthModal,
      isGiftOfferAvailable && handleOpenGiftOfferModal,
      openUnsubscribeReasonModal,
    ]
      .filter((action) => action)

    getNextAction({ actions: modalsList, index: 0 })()
  }, [ isDowngradeAvailable, isSkippable, isGiftOfferAvailable, handleOpenGiftOfferModal ])

  return {
    openCancelSubscriptionModal,
    isFetching,
  }
}


export default useCancelSubscriptionModals
